require('./angular-aria');
module.exports = 'ngAria';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-aria/index.js
 ** module id = 142
 ** module chunks = 0
 **/